import { render } from "./MarkupEditDialog.vue?vue&type=template&id=2a460fcb&scoped=true"
import script from "./MarkupEditDialog.vue?vue&type=script&lang=js"
export * from "./MarkupEditDialog.vue?vue&type=script&lang=js"

import "./MarkupEditDialog.vue?vue&type=style&index=0&id=2a460fcb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a460fcb"]])

export default __exports__